module.exports = __webpack_public_path__ + "img/MoveDashLogo.cc7fe522.svg";